import PostAPI from '@/app/apis/main/post/post-api.js';

export default {
	/**
	 * @param {*} options
	 * @returns {Promise}
	 */
	async getPosts(options) {
		return PostAPI.getPosts(options);
	},

	/**
	 * @param {Number} postId
	 * @return {Object} post
	 * */
	async getPostById(postId) {
		return PostAPI.getPostById(postId);
	},

	/**
	 * @param {Number} postId
	 * @returns {Promise}
	 */
	async deletePost(postId) {
		return PostAPI.deletePost(postId);
	}
}